export default __webpack_public_path__ + "static/media/shark-label-2.56c79a44.gif";